import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { getViewer } from "types/gql-types";
import { VIEWER_QUERY } from "../auth/query";
import Navigation, { ProfileButton } from "./navigation";
import HamburgerMenu from "./layout/menu";
import { drawerWidth } from "./layout/helpers";

const Header: React.FC<{short?: boolean}> = ({ short = false }) => {
  const { data, error } = useQuery<getViewer>(VIEWER_QUERY);
  if (error) return <div>Error loading user</div>;

  return (
    <>
      <AppBar
        position="static"
        color="secondary"
        sx={{
          backgroundColor: "#324257",
          color: "white",
          ...(short ? {} : {
            width: "100%",
            marginLeft: 0,
          }),
          ...(short && {
            "@media (min-width: 900px)": {
              width: `calc(100% - ${drawerWidth}px)`,
              marginLeft: `${drawerWidth}px`,
            },
          }),
        }}
      >
        <Toolbar>
          <Link to="/">
            <div className="header-logo-image" />
          </Link>
          <div style={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <Navigation viewer={data?.viewer}/>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <ProfileButton viewer={data?.viewer}/>
            <HamburgerMenu viewer={data?.viewer}/>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
